import React, { Component } from "react";
import {
  Container,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

export default class Quick extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
    };
    this.toggleTab = this.toggleTab.bind(this);
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  render() {
    return (
      <React.Fragment>
        <Container className="container mt-100 mt-60">
          <Row className="row justify-content-center">
            <Col xs={12}>
              <div className="section-title text-center mb-4 pb-2">
                <h6 className="text-primary">Démarage rapide</h6>
                <h4 className="title mb-4">Impressionnant n’est-ce pas? Continuons.</h4>
                <p className="para-desc mx-auto text-muted mb-0">
                  Voici quelques-unes des{" "}
                  <span className="text-primary font-weight-bold">
                    prestations
                  </span>{" "}
                  que je peux réaliser afin de vous générer de la notoriété, conduire votre trafic ou vous faire des contacts.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12} className="mt-2 pt-2">
              <div className="bg-dark bg-white-dark p-3 rounded shadow">
                <Row>
                  <Col lg={12} >
                    <Nav className="nav-pills nav-tabs nav-justified flex-column flex-sm-row rounded bg-soft-light mt-3">
                      <NavItem className="hover-border">
                        <NavLink
                          className="rounded"

                        >
                          <div className="text-center">
                            <h5 className="title font-weight-normal mb-0">
                              Création de site internet
                            </h5>
                          </div>
                        </NavLink>
                      </NavItem>

                      <NavItem className="hover-border">
                        <NavLink
                          className="rounded"

                        >
                          <div className="text-center">
                            <h5 className="title font-weight-normal mb-0">
                              Refonte d'anciens sites
                            </h5>
                          </div>
                        </NavLink>
                      </NavItem>

                      <NavItem className="hover-border">
                        <NavLink
                          className="rounded"

                        >
                          <div className="text-center">
                            <h5 className="title font-weight-normal mb-0">
                              Reprise de projet
                            </h5>
                          </div>
                        </NavLink>
                      </NavItem>

                      <NavItem className="hover-border">
                        <NavLink
                          className="rounded"

                        >
                          <div className="text-center">
                            <h5 className="title font-weight-normal mb-0">
                              Communication digitale
                            </h5>
                          </div>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                </Row>
              </div>

              <ul className="list-unstyled text-muted mb-0 mt-3">
                <li className="list-inline-item mr-lg-5 mr-4">
                  <span className="text-success h5 mr-2">
                    <i className="uil uil-check-circle align-middle"></i>
                  </span>
                  Possibilité de déplacement
                </li>
                <li className="list-inline-item mr-lg-5 mr-4">
                  <span className="text-success h5 mr-2">
                    <i className="uil uil-check-circle align-middle"></i>
                  </span>
                  Travail avec n’importe quelle équipe
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
